import React, { useEffect, useState } from 'react';
import axios from 'axios';

function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Get token from localStorage (or your auth context)
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        const res = await axios.get('https://apimyshop.myidealtd.co.uk/api/orders/myorders', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setOrders(res.data);
      } catch (err) {
        setError('Failed to fetch orders.');
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [token]);

  if (loading) return <p>Loading orders...</p>;
  if (error) return <p>{error}</p>;
  if (orders.length === 0) return <p>No orders found.</p>;

  return (
    <div>
      <h2>My Orders</h2>
      {orders.map((order) => (
        <div key={order._id} style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '15px' }}>
          <p><strong>Order ID:</strong> {order._id}</p>
          <p><strong>Status:</strong> {order.status}</p>
          <p><strong>Ordered on:</strong> {new Date(order.createdAt).toLocaleString()}</p>
          <p><strong>Total:</strong> £{order.total.toFixed(2)}</p>
          <p><strong>Products:</strong></p>
          <ul>
            {order.products.map((prod) => (
              <li key={prod.id}>
                {prod.name} x {prod.quantity} (£{prod.price.toFixed(2)} each)
              </li>
            ))}
          </ul>
          <p><strong>Shipping Address:</strong> {order.shippingAddress.address}, {order.shippingAddress.city}, {order.shippingAddress.postcode}, {order.shippingAddress.country}</p>
        </div>
      ))}
    </div>
  );
}

export default MyOrders;
